import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './ScopeOfWorkTable.module.scss';
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const ScopeOfWorkTable = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);
  const orderProfileTitle = useSelector((state: any) => state.wizard.orderProfileTitle);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Function to update the specific options item.
  const assignOptionValue = (value, id, keyName) => {
    const optionObject = updatedValues?.metaData?.[id];
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [id]: {
          ...optionObject,
          [keyName]: value
        }
      }
    };

    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
    
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {  
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  const scopeOfWorkConstants = [
    {
      id: 'false_ceiling',
      label: 'False Ceiling',
    },
    {
      id: 'floor_covering',
      label: 'Floor Covering',
    },
    {
      id: 'fc_paint',
      label: 'Paint for False ceiling',
    },
    {
      id: 'light_supply',
      label: 'Light Supply',
    },
    {
      id: 'light_installation',
      label: 'Light Installation',
    },
    {
      id: 'support_for_lights',
      label: 'Additional Support for Lights',
    },
    {
      id: 'wiring_looping',
      label: 'Wiring / Looping',
    },
    {
      id: 'creation_of_points',
      label: 'Create / Additional of Points',
    },
    {
      id: 'switch_sockets_supply',
      label: 'Switch & Sockets Supply',
    },
    {
      id: 'fan_supply',
      label: 'Fan supply',
    },
    {
      id: 'fan_rod_supply',
      label: 'Extended Fan Rod Supply',
    },
    {
      id: 'fan_rod_installation',
      label: 'Fan & Fan Rod Installation',
    },
  ];

  const OptionViewTab = (data) => {
    const { details, keyName } = data;
    return (
      <div className={style.option_view}>
      {!isDrawingsExporting ?  <select className={style.edit_select_options} onChange={(v) => assignOptionValue(v.target.value, details.id, keyName)}>
        <option value='No' selected>No</option>
        <option value='Yes' selected={updatedValues?.metaData?.[details.id]?.[keyName] === 'Yes'}>Yes</option>

      </select> : <span>{updatedValues?.metaData?.[details?.id]?.[keyName] || 'No'}</span>
      }
    </div>
    )
  }

  return (
    <section className={style.scope_work_container}>
      <h1 className="section_heading">Scope of Work Table</h1>
      <div className={style.sow_table_section}>
        <div className={style.four_col_tab_heading}>
          <p>Description</p>
          <p>CX - SOW</p>
          <p>{orderProfileTitle} - SOW</p>
          <p>Additional Details</p>
        </div>
        {
          scopeOfWorkConstants?.map((e: any, i: any) => (
            <div className={style.four_col_tab_body} key={i}>
              <p>{e?.label}</p>
              <OptionViewTab details={e} keyName={'HL_SOW'}/>
              <OptionViewTab details={e} keyName={'CX_SOW'}/>
              <p>{!isDrawingsExporting ? <input value={updatedValues?.metaData?.[e.id]?.['additional'] || ''} onChange={(v) => assignOptionValue(v.target.value, e?.id, 'additional')} /> : updatedValues?.metaData?.[e.id]?.['additional'] || ''} </p> 
            </div>
          ))
        }
      </div>
      <div className={style.note_section}>
        <p>Note:</p>
        <div>
          <p>1. Extension of Sprinklers, Fire Alarms will be in CX Scope only</p>
          <p>2. AC Installation and related piping work will be in CX Scope only</p>
        </div>
      </div>
    </section>
  )
}

export default ScopeOfWorkTable